module.exports = __webpack_public_path__ + "static/img/video-2.113c275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-2.jpg
// module id = bcpX
// module chunks = 12